import { render, staticRenderFns } from "./CFCDetail.vue?vue&type=template&id=022919fc&"
import script from "./CFCDetail.vue?vue&type=script&lang=js&"
export * from "./CFCDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports